export const LanguageOptionCodes = [
  "sq",
  "eu",
  "bs",
  "bg",
  "ca",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "et",
  "fi",
  "fr",
  "de",
  "el",
  "hu",
  "is",
  "ga",
  "it",
  "lv",
  "lt",
  "lb",
  "mk",
  "mt",
  "no",
  "pl",
  "pt",
  "ro",
  "sr",
  "sk",
  "sl",
  "es",
  "sv",
  "tr",
  "uk",
  "cy",
  "ru",

  "de-at",
  "en-us",
  "en-gb",
] as const;

// #53348 #55643 Default country mapping for single language codes (ISO 639-1 + ISO 3166-1 alpha-2).
export const defaultRegionMap: Record<string, string> = {
  sq: "AL", // Albanian — Albania
  eu: "ES", // Basque — Spain
  bs: "BA", // Bosnian — Bosnia & Herzegovina
  bg: "BG", // Bulgarian — Bulgaria
  ca: "ES", // Catalan — Spain
  hr: "HR", // Croatian — Croatia
  cs: "CZ", // Czech — Czechia
  da: "DK", // Danish — Denmark
  nl: "NL", // Dutch — Netherlands
  en: "GB", // English — United Kingdom
  et: "EE", // Estonian — Estonia
  fi: "FI", // Finnish — Finland
  fr: "FR", // French — France
  de: "DE", // German — Germany
  el: "GR", // Greek — Greece
  hu: "HU", // Hungarian — Hungary
  is: "IS", // Icelandic — Iceland
  ga: "IE", // Irish — Ireland
  it: "IT", // Italian — Italy
  lv: "LV", // Latvian — Latvia
  lt: "LT", // Lithuanian — Lithuania
  lb: "LU", // Luxembourgish — Luxembourg
  mk: "MK", // Macedonian — North Macedonia
  mt: "MT", // Maltese — Malta
  no: "NO", // Norwegian — Norway
  pl: "PL", // Polish — Poland
  pt: "PT", // Portuguese — Portugal
  ro: "RO", // Romanian — Romania
  sr: "RS", // Serbian — Serbia
  sk: "SK", // Slovak — Slovakia
  sl: "SI", // Slovene — Slovenia
  es: "ES", // Spanish — Spain
  sv: "SE", // Swedish — Sweden
  tr: "TR", // Turkish — Turkey
  uk: "UA", // Ukrainian — Ukraine
  cy: "GB", // Welsh — United Kingdom (GB)
  ru: "RU", // Russian — Russia
};
